var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"lineup-container"},[_c('div',{staticClass:"lineup-container__lineup-view"},[_c('LineupPlayers')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }